import { ExportOutlined } from '@ant-design/icons';
import React from 'react';
import {
  BottomWrapper,
  Middle,
  Shared,
  Top,
  Wrapper,
} from './ProjectSummary.style';

interface ProjectSummaryData {
  title?: string;
  title2?: string;
}
interface ProjectSummaryProps {
  projectSummaryData: ProjectSummaryData;
}
const ProjectSummary: React.FC<ProjectSummaryProps> = ({
  projectSummaryData,
}) => {
  return (
    <Wrapper data-test={'project-summary'}>
      <Top>{projectSummaryData.title}</Top>
      <Middle>{projectSummaryData.title2}</Middle>
      <BottomWrapper>
        <Shared>
          <ExportOutlined /> Share
        </Shared>
      </BottomWrapper>
    </Wrapper>
  );
};

export default ProjectSummary;
